import React, { useState, useEffect } from 'react';
import { Grid, Tabs, Tab, Box } from '@mui/material';
import { ContentSeparator } from '@core/components';
import { FeriasCard } from './components/ferias-cards';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { useAppSelector } from '@store/hooks';
import { colaboradorService } from '@core/services';
import { getYearFromDate } from '@core/utils';
import { selectorPeriodoFerias } from '@core/slice/periodoFerias.slice';
import { AlertComponent } from '@core/components/atoms/alert-component';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface IFeriasProps {}

export const Ferias: React.FC<IFeriasProps> = () => {
    const [value, setValue] = useState(0);
    const { data, loading, error } = useAppSelector(selectorPeriodoFerias);

    useEffect(() => {
        colaboradorService.buscarPeriodoFerias();
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    function CustomTabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
                {value === index && (
                    <Box sx={{ pt: 0, px: 2, pb: 2 }}>
                        <Grid>{children}</Grid>
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`
        };
    }

    return (
        <Box sx={{ width: '100%', mt: -3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Box maxWidth="xl" style={{ margin: '0 auto' }}>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Abertos" {...a11yProps(0)} />
                        <Tab label="Quitados" {...a11yProps(1)} />
                    </Tabs>
                </Box>
            </Box>
            <Box maxWidth="xl" style={{ margin: '0 auto' }}>
                <CustomTabPanel value={value} index={0}>
                    <Grid container>
                        {error && !loading ? (
                            <AlertComponent type="error" detailed={true} message={error ?? '-'} />
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    <ContentSeparator title="Período atual" />
                                </Grid>

                                {data && Array.isArray(data)
                                    ? data.map((periodoFerias, index) => {
                                          let fimPeriodoYear = getYearFromDate(periodoFerias.fimPeriodo);
                                          let currentYear = new Date().getFullYear();

                                          if (periodoFerias.status === 'Aberto' && Number(fimPeriodoYear) <= Number(currentYear)) {
                                              return (
                                                  <FeriasCard
                                                      key={index}
                                                      path={PathsEnum.DETALHESPERIODO}
                                                      inicioPeriodo={periodoFerias.inicioPeriodo}
                                                      fimPeriodo={periodoFerias.fimPeriodo}
                                                      diasFerias={periodoFerias.diasFerias}
                                                      status={periodoFerias.status}
                                                  />
                                              );
                                          } else {
                                              return null;
                                          }
                                      })
                                    : null}

                                <Grid item xs={12}>
                                    <ContentSeparator title="Períodos futuros" />
                                </Grid>

                                {data && Array.isArray(data)
                                    ? data.map((periodoFerias, index) => {
                                          let fimPeriodoYear = getYearFromDate(periodoFerias.fimPeriodo);
                                          let currentYear = new Date().getFullYear();

                                          if (periodoFerias.status === 'Aberto' && Number(fimPeriodoYear) > Number(currentYear)) {
                                              return (
                                                  <FeriasCard
                                                      key={index}
                                                      path={PathsEnum.DETALHESPERIODO}
                                                      inicioPeriodo={periodoFerias.inicioPeriodo}
                                                      fimPeriodo={periodoFerias.fimPeriodo}
                                                      diasFerias={periodoFerias.diasFerias}
                                                      status={periodoFerias.status}
                                                  />
                                              );
                                          } else {
                                              return null;
                                          }
                                      })
                                    : null}
                            </>
                        )}
                    </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <Grid container>
                        {error && !loading ? (
                            <AlertComponent type="error" detailed={true} message={error ?? '-'} />
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    <ContentSeparator title="Períodos quitados" />
                                </Grid>

                                {data && Array.isArray(data)
                                    ? data.map((periodoFerias, index) =>
                                          periodoFerias.status === 'Quitado' ? (
                                              <FeriasCard
                                                  key={index}
                                                  path={PathsEnum.DETALHESPERIODO}
                                                  inicioPeriodo={periodoFerias.inicioPeriodo}
                                                  fimPeriodo={periodoFerias.fimPeriodo}
                                                  diasFerias={periodoFerias.diasFerias}
                                                  status={periodoFerias.status}
                                              />
                                          ) : (
                                              ''
                                          )
                                      )
                                    : ''}
                            </>
                        )}
                    </Grid>
                </CustomTabPanel>
            </Box>
        </Box>
    );
};
